import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react';

import classes from './TitleBlock.module.scss';
import { PromoCodeStatus, statusFilterOptions } from '../../../constants/promoCodes';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { PageTitle } from '../../../../shared/components/ui-components';
import { addAllOption } from '../../../../shared/utils/arrayUtils';
import { Select } from '../../../../shared/components/form-components';

type TitleBlockProps = {
  filterValue: PromoCodeStatus | null;
  onChangeFilterValue: (value: PromoCodeStatus | null) => void;
  onAddPromoCodeButtonClick: () => void;
};

const TitleBlock = observer(
  ({ filterValue, onChangeFilterValue, onAddPromoCodeButtonClick }: TitleBlockProps) => {
    const { isEntity } = loggedInUserDataStore;

    const options = addAllOption(statusFilterOptions);

    return (
      <PageTitle title="Promo codes" customTopMargin>
        <div className={classes.titleControls}>
          <Select
            value={filterValue || ''}
            options={options}
            onChange={(value) => onChangeFilterValue(value || null)}
            label="Status"
            variant="outlined"
            displayEmpty
            className={classes.filterInput}
          />
          {isEntity && (
            <Button variant="contained" size="medium" onClick={onAddPromoCodeButtonClick}>
              + Add a Promo Code
            </Button>
          )}
        </div>
      </PageTitle>
    );
  },
);

export { TitleBlock };
